import { useState } from 'react'

/**
 * @function
 * @description Returns a function that can be used to forcefully re-render a component.
 * @returns {Function} function that can be used to forcefully re-render a component.
 */
const useForceRender = () => {
  const [, setValue] = useState(false)
  return () => setValue(value => !value)
}

export default useForceRender